import { isValidUrl } from "pages/utils";

import {
  AllPageConfigKeys,
  DEFAULT_CONFIG,
  ENABLED_KEY,
  ExternalLink,
  PageConfigValues,
  PagesConfig,
  VALID_PAGE_CONFIG_IDS,
} from "./types";

export const isValidExternalLinkUrl = (url: string) =>
  /^https?:\/\//i.test(url) && isValidUrl(url);

export const isVisibleExternalLink = ({ title, url }: ExternalLink) =>
  title.trim() !== "" && isValidExternalLinkUrl(url);

const isExternalLink = (link: unknown): link is ExternalLink =>
  typeof link === "object" &&
  link !== null &&
  "id" in link &&
  typeof link.id === "string" &&
  "title" in link &&
  typeof link.title === "string" &&
  "url" in link &&
  typeof link.url === "string";

export const getExternalLinks = (links: unknown): ExternalLink[] =>
  Array.isArray(links) ? links.filter(isExternalLink) : [];

export const updateConfig = (
  prevConfig: PagesConfig,
  pageID: AllPageConfigKeys,
  configKey: string,
  configValue: PageConfigValues
): PagesConfig => {
  if (configKey === ENABLED_KEY) {
    if (configValue) {
      if (prevConfig.some(({ ID }) => ID === pageID)) {
        return prevConfig;
      }

      return [
        ...prevConfig,
        {
          ID: pageID,
          config: DEFAULT_CONFIG,
        },
      ];
    } else {
      return prevConfig.filter((item) => item.ID !== pageID);
    }
  }

  return prevConfig.map((item) =>
    item.ID === pageID
      ? { ...item, config: { ...item.config, [configKey]: configValue } }
      : item
  );
};

export const filterToValidPageConfigEntries = (
  config: PagesConfig
): PagesConfig => config.filter(({ ID }) => VALID_PAGE_CONFIG_IDS.has(ID));

export const getStalePageConfigEntries = (config: PagesConfig): PagesConfig =>
  config.filter(({ ID }) => !VALID_PAGE_CONFIG_IDS.has(ID));
